import { FC, Fragment } from 'react';

import { SkeletonBaseSmall } from '../SkeletonBase/SkeletonBaseSmall/SkeletonBaseSmall';
import { SkeletonBaseLarge } from '../SkeletonBase/SkeletonBaseLarge/SkeletonBaseLarge';

interface SkeletonFeedProps {
  count?: number;
}

export const SkeletonFeed: FC<SkeletonFeedProps> = ({ count = 3 }) => {
  return (
    <Fragment>
      {Array.from({ length: count }).map((_, index) => (
        <Fragment key={index}>
          <SkeletonBaseSmall />
          <SkeletonBaseSmall />
          <SkeletonBaseLarge />
        </Fragment>
      ))}
    </Fragment>
  );
};
